import { Card } from '@/components/ui/card'

/** Shown in place of the card list when the organization has no assessments. */
export function AssessmentEmptyState() {
  return (
    <Card className="p-12 text-center">
      <p className="mb-2 text-lg font-semibold text-body">No assessments yet</p>
      <p className="text-sm text-subtle">
        Your organization has no assessments available at the moment. When one is assigned, it will
        appear here.
      </p>
    </Card>
  )
}
